import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { BusinessUser } from '@models/businesses';
import { MatterFileType } from '@models/matter';
import { Select } from '@ngxs/store';
import { BusinessUsersState } from '@state/business-users/business-users.state';
import { Observable } from 'rxjs';
import { NavigationService } from 'src/app/shared/services/nav/nav.service';
import { TestHooks } from './payment-required.hooks';

@Component({
	selector: 'app-payment-required',
	templateUrl: './payment-required.component.html',
	styleUrls: ['./payment-required.component.scss'],
	standalone: false,
})
export class PaymentRequiredComponent {
	testHooks = TestHooks;
	@Output() public onReset = new EventEmitter();
	@Input() public fileType: MatterFileType;
	@Select(BusinessUsersState.getAdmins) admins$: BusinessUser[];
	@Select(BusinessUsersState.isLoggedInUserAdmin)
	isLoggedInUserAdmin$: Observable<boolean>;

	public matterTypes = MatterFileType;

	constructor(
		public dialogRef: MatDialogRef<PaymentRequiredComponent>,
		public navigationService: NavigationService,
	) {}

	public close(): void {
		if (this.fileType) {
			this.onReset.emit();
		} else {
			this.dialogRef.close();
		}
	}

	public goToBilling(): void {
		this.navigationService.goToManage_Business_Billing();
		this.dialogRef.close();
	}
}
